import { Outlet, useParams } from 'react-router-dom';
import { Page } from '../../util/sections';
import { useUpdatePage } from '../../hooks/useUpdatePage';

interface QuestionnaireRoutesProps {
  page?: Page;
}

export const QuestionnaireRoutes = ({ page }: QuestionnaireRoutesProps) => {
  const params = useParams();
  const nextPage = page ?? (params.page?.toUpperCase() as Page);
  useUpdatePage(nextPage);

  return <Outlet />;
};
